import React, { FC } from 'react'
import {
  PaperBlock,
  PaperBlockReq,
  PaperQuestion,
  QuestionTypeEnum,
} from 'packages/sdks-next/growp'
import { CommonScoreSetting } from './ScoreSettingItems/CommonScoreSetting'
import { FillInBlankScoreSetting } from './ScoreSettingItems/FillInBlankScoreSetting'
import styled from 'styled-components'
import { ProductScoreSetting } from './ScoreSettingItems/ProductScoreSetting'

export const Render: FC<{
  block: PaperBlock
  serialNumber: number
  onUpdateScore: (blockId: number, payload: PaperBlockReq) => void
}> = (props) => {
  const { block } = props
  const mainQuestionBlock = block.questions?.filter((q) => q.parentId === 0)
  const mainQuestion = mainQuestionBlock?.length
    ? mainQuestionBlock[0]
    : undefined
  const getScoreComponent = (question: PaperQuestion, index: number) => {
    switch (question.type) {
      case QuestionTypeEnum.SingleChoice:
      case QuestionTypeEnum.ShortAnswer:
      case QuestionTypeEnum.MultipleChoice: {
        return (
          <CommonScoreSetting
            {...props}
            question={question}
          />
        )
      }
      case QuestionTypeEnum.FillInBlank: {
        return (
          <FillInBlankScoreSetting
            {...props}
            question={question}
            curIndex={index}
          />
        )
      }
      default:
        return null
    }
  }

  if (mainQuestion?.type === QuestionTypeEnum.Product) {
    return (
      <ProductScoreSetting
        {...props}
        mainQuestion={mainQuestion}
      />
    )
  }

  return (
    <Wrapper>
      {block.questions
        ?.sort((a, b) => (a.weight || 0) - (b.weight || 0))
        .map((question: PaperQuestion, index: number) => {
          return (
            <React.Fragment key={index}>
              {getScoreComponent(question, index)}
            </React.Fragment>
          )
        })}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
